<script>
  import currentUser from '../../stores/auth';
  import db from '../../db'
  import Loader from '../../components/Loader.svelte'

  let password = "";
  let passwordErrorMsg = "";
  let isSaving = false;

  let passwordUpdated = false;

  async function onSave() {
    passwordErrorMsg = "";

    if (password.length < 8) {
      passwordErrorMsg = "Password should be at least 8 characters";
      return;
    }

    isSaving = true;

    try {
      const {user, error} = await db.auth.update({
        password,
      });

      if (error) passwordErrorMsg = error.message;
      else passwordUpdated = true;
    } catch (err) {
      passwordErrorMsg = "Error has occured while setting new password";
    } finally {
      isSaving = false;
    }
  }
</script>

<section class="nes-container is-dark is-rounded">
  {#if isSaving}<Loader text="Saving..." />{/if}

  {#if $currentUser}
    {#if passwordUpdated}
      <p class="nes-text is-success">Password has been updated.</p>
    {:else}
      {#if $currentUser.user && $currentUser.user.email}
        <div class="nes-field">
          <label for="email">Email</label>
          <p id="email">{$currentUser.user.email}</p>
        </div>
      {/if}

      <div class="nes-field">
        <label for="password">New password</label>
        <input type="password" id="password" class="nes-input is-dark"
               required bind:value={password}
        >
        <div class="nes-text is-error">{passwordErrorMsg}</div>
      </div>

      <button type="button" class={`nes-btn ${isSaving ? 'is-disabled' : 'is-primary'}`} on:click={onSave}
              class:disabled={isSaving}>Save
      </button>
    {/if}
  {:else}
    <p class="nes-text is-error">
      This page is available for authenticated users only. Please log in.
    </p>
  {/if}
</section>

<style>
    .nes-text, .nes-btn {
        margin-top: .5rem;
    }
</style>